import { render, staticRenderFns } from "./text.vue?vue&type=template&id=1e555c82"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./text.vue?vue&type=custom&index=0&blockType=skeleton"
if (typeof block0 === 'function') block0(component)

export default component.exports